<template>
  <div id="member">
        <!-- all_in -->
        <div class="break_box">
            <Breadcrumb>
                <breadcrumbs></breadcrumbs>
            </Breadcrumb>
        </div>
        <!-- <div class="con_all">
            <div class="con_box2">
                <div class="site_pic"><img src="/../static/images/u19394.jpg"></div>
                <div class="site_link"><a href="">1.綜合體育館介紹</a></div>
                <div class="site_link"><a href="">2.籃球場</a></div>
            </div>
        </div> -->
        <router-view></router-view>
    </div>
</template>

<script>


export default {
  name: 'member',
  data() {
    return {};
  },
  methods: {
  },
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// Member.vue?a1a7bfde